<template>
    <div class="preloader" v-bind:class="{ 'preloader-compact': compact }"></div>
</template>

<script>
export default {
    props: ['compact']
}
</script>
